import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DmtService {
  loggedInSender = new BehaviorSubject('');
  editBenefi = new BehaviorSubject('');
  constructor(private http: HttpClient) { }

sendOtp(mobileNo,type){
  const params ={
    phone: mobileNo,
    type:type
  }
  let headers = new HttpHeaders();
  headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

  return this.http.post(`${environment.youmudraUrl}/v1/user/dmtverifyUserOtp`, params,{headers:headers});
}
sendOtp2(value){
  // const params ={
  //   phone: mobileNo,
  //   type:type
  // }
  let headers = new HttpHeaders();
  headers = headers.append("authToken",localStorage.getItem('wallet-token'));

  return this.http.get(`${environment.validate_url}/ym/retailor/sendotp/transfer/todistributor?otpOn=${value}`,{headers:headers});
}

validateOtp(params){
  let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

  return this.http.post(`${environment.youmudraUrl}/v1/user/validateUserOtp`, params,{headers:headers});
}

addMoneySender(params){
  let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

  return this.http.post(`${environment.youmudraUrl}/v1/user/addSender`, params,{headers:headers})
}
  bebificiaryList() {
    return this.http.get('../../assets/benificiary.json');
  }
  senderList(mobNo) {
    return this.http.get(`${environment.allienceBaseUrl}/v1/sender/${mobNo}`);
  }
  addSender(sendFormValue) {
    return this.http.post(`${environment.allienceBaseUrl}/v1/dmtSender/create`, sendFormValue);
  }
  allSenderList() {
    const agentId = localStorage.getItem('userId');
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/user/senderList/${agentId}`,{headers:headers});
  }
  getbenificiaryList(sendId){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/user/getallbenificiary/${sendId}`,{headers:headers});
  }
  getDMTLimitSender(mobileNo){
    let headers = new HttpHeaders();
    const token = localStorage.getItem('wallet-token');
    // (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
    
    return this.http.get(`${environment.walletUrl}/ym/retailor/getdmtlimit?mobileNumber=${mobileNo}`,{headers:headers});

  }
  commissionPlanApi(amount,mode){
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.walletUrl}/ym/retailor/calculate/dmt/commission?amount=${amount}&transactiontype=${mode}`,{headers:headers});


  }
  updateTrans(params){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/user/updatetransaction`, params,{headers:headers});
  }

  blockBenificiary(params){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/user/activatedeactivateBeni`, params,{headers:headers});
  }
  dmtImps(params, type){
    let userType = localStorage.getItem('userType');
    const agentId = JSON.parse(localStorage.getItem('currentUser')).data.agentId;

    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
      if(type == 'imps'){
        return this.http.post(`${environment.baseUrl}/v1/api/retailor/dmt/transaction?transactionType=IMPS`, params, { headers: headers });
      }else if(type == 'neft'){
        return this.http.post(`${environment.baseUrl}/v1/api/retailor/dmt/transaction?transactionType=NEFT`, params, { headers: headers });
      }
    
  }
  accountDetailsVerify(accdetails) {
    var type="DMT";
    var bene=accdetails.Accdetails;
    var mobile = bene.mobile;
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
  
  var data={
  bankAccountNumber: bene.account_no,
  ifsccode: bene.ifc_code,
  nameOnBank: bene.beneficiary_name,
  phoneNumber: bene.mobile
   
  }
  console.log(data);
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/verify/bankAccount?mobileNumber=${mobile}&type=${type}`,data,{headers:headers});
  }
  updatebeneDetailsAfterVerification(nameOnBank,accdetails){
    var bene=accdetails.Accdetails;
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data={
      "beneficiary_name": nameOnBank,
      "_id":bene._id 
      }
    return this.http.post(`${environment.youmudraUrl}/v1/user/dmtupdatebenificiary`,data,{headers:headers});

  }
  bankverifyUpdate(accdetails){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var bene=accdetails.Accdetails;

    var data={
      bankVerify: true,
      _id:bene._id 
      }
    return this.http.post(`${environment.youmudraUrl}/v1/user/benefiarybankVerify`,data,{headers:headers});


  }
  updateTransactionLimit(amount,getdata){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data = {
      amount: amount,
      senderMobile: getdata.mobile,
      date: getdata.transactionDate,
      _id: getdata._id
    }
    
    return this.http.post(`${environment.youmudraUrl}/v1/user/updatetransaction`,data,{headers:headers});
  
  }
  setLoggedInSenderDetails(details) {
    this.loggedInSender.next(details);
  }
  globalSenderList(mobile){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/user/globalSender/${mobile}`,{headers:headers})
  }
addDmtBenificiary(formsvals){
  let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

  return this.http.post(`${environment.youmudraUrl}/v1/user/dmtaddbenificiary`, formsvals,{headers:headers});
}

  getLoggedInSenderDetails() {
    return this.loggedInSender.asObservable();
  }
  addbeneficiary(params) {
    return this.http.post(`http://localhost:3000/v1/addbeneficiary`, params);
  }
  
  getifc(req,bankName){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/user/findBankswithifsc?size=${req.size}&page=${req.page}&bankName=${bankName}`,{headers:headers});
  // https://uatapionboarding.yourmudra.com/v1/user/findBankswithifsc?size=20&page=1&bankName=
  }
  // getifc(uacid){
  //   return this.http.get(`${environment.youmudraUrl}/v1/retailer/fetchbanks?uacid=${uacid}`);

  //   // retailer/fetchbanks?uacid=
  // }
  checkBeneAccount(accountNumber,senderId){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data={
      account_no :accountNumber,
      senderId:senderId

     }
    return this.http.post(`${environment.youmudraUrl}/v1/user/checkbenificiary`,data,{headers:headers});

  }
  deleteBene(id){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

  var data={
   id :id 
  }
    
    return this.http.post(`${environment.youmudraUrl}/v1/retailer/deleteRetailerbank`,data,{headers:headers});

  }
  setEditBene(details) {
    this.editBenefi.next(details);
  }
  
  getEditBene() {
    return this.editBenefi.asObservable();
  }

  editBene(element,form){
    console.log("element",element);
    console.log("form",form);
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data={
      _id:element._id,
      beneficiary_name:form.beneficiary,
      account_no:form.accno,
      ifc_code:form.ifsccode,
      bank_name:form.bank,
      mobile:form.mobileNo,
      senderId:element.senderId,
      bankVerify:element.bankVerify,
      block:element.block,
      dailyTransfer:element.dailyTransfer,
      kyc:element.kyc,          
      transferLimit:element.transferLimit
    }
      return this.http.post(`${environment.youmudraUrl}/v1/user/updateDmtBeni`,data,{headers:headers});
  
    }
    
  panverification(panNo) {
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.baseUrl}/v1/allianceapi/verify/panNumber?panNumber=${panNo}`, { headers: headers });
  }
  aadharVerification(aadharno) {
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.baseUrl}/v1/allianceapi/verify/aadharNumber?aadharNumber=${aadharno}`, { headers: headers });
  }
//YES BANK DMT APIS

allSenderListYesBank(limit,offset) {
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  return this.http.get(`${environment.validate_url}/ym/yesbank/retailor/dmt/fetchall/customer?limit=${limit}&offset=${offset}`, { headers: headers });
}
getbenificiaryListYesBank(limit,offset,mobile){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  return this.http.get(`${environment.validate_url}/ym/yesbank/retailor/dmt/fetchallbene/bycustomer?limit=${limit}&offset=${offset}&number=${mobile}`, { headers: headers });

}

updateCustomereKyc(form){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  let data={
    
      "addressDocNo": "string",
      "addressDocType": "string",
      "cardStatus": "string",
      "customerMob": "string",
      "identityDocNo": "string",
      "identityDocType": "string",
      "kycStatus": "string",
      "pancardStatus": "string"
    
  }
  return this.http.get(`${environment.validate_url}/ym/yesbank/retailor/dmt/updatekyc`, { headers: headers });

}

searchSenderList(limit,offset,number){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  
  return this.http.get(`${environment.validate_url}/ym/yesbank/retailor/dmt/fetchall/bymobile/customer?limit=${limit}&offset=${offset}&number=${number}`, { headers: headers });
  // v1/ym/yesbank/retailor/dmt/fetchall/bymobile/customer?limit=10&offset=0&number=7454957737
}

getFingerYesBankKyc(){
  return this.http.get(`${environment.validate_url}/ym/admin/get/finger`);

}
getDevicesYesBankKyc(){
  return this.http.get(`${environment.validate_url}/ym/admin/get/device`);

}
yesBankKycSendOtp(){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  
  return this.http.get(`${environment.validate_url}/ym/retailor/yesbank/initiateotp`, { headers: headers });
 
}
yesBankKycVerifyOtp(otp,otpToken){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  var data=
    {
      "otp": otp,
      "otpToken": otpToken
    }
  
  return this.http.post(`${environment.validate_url}/ym/retailor/yesbank/validateotp`,data,{ headers: headers });
}
generateWadh(kycToken){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  var data=
  {
    "kycToken": kycToken
  }
  return this.http.post(`${environment.validate_url}/ym/retailor/yesbank/generate/aadharwadh`,data,{ headers: headers });

}
yesBankKycDone(param,latitute,longitute){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  
  return this.http.post(`${environment.validate_url}/ym/retailor/yesbank/done/ekyc?latitute=${latitute}&longitute=${longitute}`,param,{ headers: headers });
}

yesBankAddCustomer(form){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  var data=
  {
    "address": form.address,
    "addressDocNo": "string",
    "addressDocType": "string",
    "cardStatus": "0",
    "city": form.city,
    "customerMob": form.mobile,
    "dateOfBirth": form.dob,
    "district":form.district,
    "gender": form.gender,
    "identityDocNo": "string",
    "identityDocType": "string",
    "isOTPValidated": "0",
    "name": form.name,
    "pancardStatus": "0",
    "pincode": "string",
    "productCode": [
      "DMT"
    ],
    "state": form.state,
    "title": form.title,
    
  }
  return this.http.post(`${environment.validate_url}/ym/yesbank/retailor/dmt/createcustomer`,data,{ headers: headers });
}

generateOtpYesBank(form,mobileNo){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  
  var data={
    "benefAccNo": form.account_no,
    "customerMob": mobileNo,
    "name": form.name
  }
  return this.http.post(`${environment.validate_url}/ym/yesbank/retailor/dmt/generatebenotp`,data,{ headers: headers });

}
createBeneficiaryYesBank(form,otp){
  let headers = new HttpHeaders();
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  headers = headers.append('authToken', token);
  
   var data={
    address1: form.address,
    benefAccNo:form.account_no,
    benefIfscCode:form.ifsc,
    benefMob: form.benemobile,
    city: form.city,
    customerMob: form.mobile,
    "lname": "string",
    "mname": "string",
    name: form.name,
    otp: otp,
    pincode: form.pincode,
    title: form.title
  }
  return this.http.post(`${environment.validate_url}/ym/yesbank/retailor/dmt/createbeneficiary`,data,{ headers: headers });

}
}
